import React from 'react';
import TriggerRetsOpenHouseUpdatePageContent from './TriggerRetsOpenHouseUpdatePageContent';
import { TriggerRetsOpenHouseUpdatePageProvider } from './TriggerRetsOpenHouseUpdatePageContext';

const TriggerRetsListingUpdatePage: React.FC = () => (
    <TriggerRetsOpenHouseUpdatePageProvider>
      <TriggerRetsOpenHouseUpdatePageContent />
    </TriggerRetsOpenHouseUpdatePageProvider>
  );

export default TriggerRetsListingUpdatePage;
